export default __webpack_public_path__ + "static/media/Step3.d220c6f8.svg";